import { defineMessages } from "react-intl";
const messages = defineMessages({
    filterDatesDays: {
        id: "app.scanCompleted.table.filterPeriods.buttonToday",
        defaultMessage: "Past {days}d",
    },
    filterDatesToday: {
        id: "app.scanCompleted.table.filterPeriods.buttonDays",
        defaultMessage: "Today",
    },
});
export default messages;
